<!-- <div class="release-notification" [hidden]="!showReleaseNotification">
  <img src="assets/images/general/confetti.svg" aria-hidden="true" />
  <span> We updated our transfer app and gave it a whole new look! </span>
</div> -->

<div id="side-image" class="image-fader">
  <div class="logo from-left">
    <a href="https://www.covercy.com/"> <img src="/assets/images/logo/covercy-logo-all-white.svg" /> </a>
  </div>
  <div class="content">
    <span class="slogan-header from-left"> <ng-content select=".welcome-text"></ng-content> </span>
    <div class="description from-left">
      <p><ng-content select=".welcome-sub-text"></ng-content></p>
    </div>
  </div>
</div>
<div class="form-content-wrapper terra-error-style"><ng-content select=".form-content"> </ng-content></div>
